module.exports = {
      id: "icon-star-usage",
      viewBox: "0 0 30.754 29.435",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }